module.exports = __webpack_public_path__ + "assets/img/hamburger-menu.a535991e.svg";